/**
 * LeanIQ Offer Buy Box — gallery, flavor, qty, plan, ATC
 */
(function () {
  'use strict';

  function money(n) {
    return '$' + Number(n).toFixed(2);
  }

  function parseMoney(str) {
    var n = parseFloat(String(str || '').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  /**
   * Email / deep links: ?flavor=pm|bl (aliases ok) or ?variant=<id>
   * Pair with #offers to scroll to the buy box.
   */
  function flavorFromUrl(cfg) {
    try {
      var params = new URLSearchParams(window.location.search || '');
      var flavor = String(params.get('flavor') || params.get('Flavour') || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-');
      var variant = String(params.get('variant') || '')
        .trim()
        .replace(/^.*\//, '');

      var map = {
        pm: 'pm',
        peach: 'pm',
        'peach-mango': 'pm',
        peach_mango: 'pm',
        peachmango: 'pm',
        bl: 'bl',
        blueberry: 'bl',
        'blueberry-lemonade': 'bl',
        blueberry_lemonade: 'bl',
        blueberrylemonade: 'bl'
      };
      if (flavor && map[flavor]) return map[flavor];

      if (variant) {
        var flavors = (cfg && cfg.flavors) || {};
        var keys = Object.keys(flavors);
        for (var i = 0; i < keys.length; i++) {
          var f = flavors[keys[i]] || {};
          var id = f.variantId ? String(f.variantId).replace(/^.*\//, '') : '';
          if (id && id === variant) return keys[i];
        }
        var variantsMap = (cfg && cfg.variants) || {};
        for (var k in variantsMap) {
          if (!Object.prototype.hasOwnProperty.call(variantsMap, k)) continue;
          if (String(variantsMap[k]).replace(/^.*\//, '') === variant) return k;
        }
      }
    } catch (e) {
      /* ignore */
    }
    return '';
  }

  function scrollToOffersIfHash(root) {
    if (window.location.hash !== '#offers') return;

    var hasFlavorParam = false;
    try {
      var params = new URLSearchParams(window.location.search || '');
      hasFlavorParam = !!(params.get('flavor') || params.get('Flavour') || params.get('variant'));
    } catch (e) {
      /* ignore */
    }

    var isNarrow = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var target = null;
    // Email deep links + mobile: land on the flavor picker, not the gallery top.
    if ((hasFlavorParam || isNarrow) && root) {
      target =
        root.querySelector('.liq-buybox__flavor-block') ||
        root.querySelector('[data-liq-flavors]');
    }
    if (!target) target = document.getElementById('offers');
    if (!target) return;

    function stickyHeaderOffset() {
      var styles = window.getComputedStyle(document.body);
      var group = parseFloat(styles.getPropertyValue('--header-group-height')) || 0;
      var header = parseFloat(styles.getPropertyValue('--header-height')) || 0;
      var fromCss = Math.max(group, header);
      if (fromCss > 0) return fromCss + 12;

      var sticky =
        document.querySelector('header-component') ||
        document.querySelector('#header-group') ||
        document.querySelector('sticky-header') ||
        document.querySelector('header');
      if (sticky) {
        var h = sticky.getBoundingClientRect().height;
        if (h > 40) return Math.ceil(h) + 12;
      }
      return isNarrow ? 72 : 96;
    }

    function go(behavior) {
      var top = target.getBoundingClientRect().top + (window.pageYOffset || window.scrollY || 0);
      // Sit just under the sticky header so Flavor is fully visible.
      var headerOffset = stickyHeaderOffset();
      window.scrollTo({
        top: Math.max(0, top - headerOffset),
        behavior: behavior || 'smooth'
      });
    }

    window.setTimeout(function () {
      go('smooth');
    }, 80);
    // Re-pin after gallery/layout settles so flavor stays at the top.
    window.setTimeout(function () {
      go('auto');
    }, 400);
    window.setTimeout(function () {
      go('auto');
    }, 900);
  }

  function init(root) {
    if (!root || root.dataset.liqBuyboxReady === '1') return;
    root.dataset.liqBuyboxReady = '1';

    var cfg = {};
    try {
      var cfgId = root.getAttribute('data-liq-buybox-config');
      var cfgEl = cfgId ? document.getElementById(cfgId) : null;
      if (cfgEl) {
        cfg = JSON.parse(cfgEl.textContent || '{}');
      }
    } catch (e) {
      cfg = {};
    }

    var urlFlavor = flavorFromUrl(cfg);
    var state = {
      slide: 0,
      thumbOffset: 0,
      realCount: 0,
      looping: false,
      snapping: false,
      flavor: urlFlavor || cfg.defaultFlavor || 'pm',
      plan: cfg.defaultPlan || 'sub',
      qty: 1,
      openAcc: -1
    };

    var subUnit = parseMoney(cfg.subPrice) || 44.99;
    var onceUnit = parseMoney(cfg.oncePrice) || 59.99;
    var maxQty = parseInt(cfg.maxQty, 10) || 6;
    var variants = cfg.variants || {};
    var sellingPlanId = cfg.sellingPlanId || '';
    var travelPackVariantId = cfg.travelPackVariantId || '';
    var addTravelPackGift = cfg.addTravelPackGift !== false;
    var showCtaLoading = cfg.ctaLoading !== false;
    var ctaLoadingLabel = cfg.ctaLoadingLabel || 'Adding...';
    var THUMB_VISIBLE = 5;

    var mainImg = root.querySelector('[data-liq-main-img]');
    var thumbsWrap = root.querySelector('[data-liq-thumbs]');
    var thumbsTrack = root.querySelector('[data-liq-thumbs-track]');
    var slides = cfg.slides || [];
    var flavorBtns = root.querySelectorAll('[data-liq-flavor]');
    var qtyEl = root.querySelector('[data-liq-qty]');
    var planCards = root.querySelectorAll('[data-liq-plan]');
    var subPriceEl = root.querySelector('[data-liq-sub-price]');
    var subWasEl = root.querySelector('[data-liq-sub-was]');
    var oncePriceEl = root.querySelector('[data-liq-once-price]');
    var ctaBtn = root.querySelector('[data-liq-cta]');
    var ctaLabel = root.querySelector('[data-liq-cta-label]');
    var tasteEl = root.querySelector('[data-liq-taste]');
    var giftsWrap = root.querySelector('[data-liq-gifts]');
    var statusEl = root.querySelector('[data-liq-status]');
    var form = root.querySelector('[data-liq-form]');
    var idInput = root.querySelector('[data-liq-variant-id]');
    var qtyInput = root.querySelector('[data-liq-qty-input]');
    var planInput = root.querySelector('[data-liq-selling-plan]');
    var accItems = root.querySelectorAll('[data-liq-acc]');

    function getThumbButtons() {
      return thumbsTrack
        ? thumbsTrack.querySelectorAll('[data-liq-thumb], [data-liq-thumb-clone]')
        : [];
    }

    function getRealThumbs() {
      return thumbsTrack ? thumbsTrack.querySelectorAll('[data-liq-thumb]') : [];
    }

    function thumbGap() {
      if (!thumbsWrap) return 10;
      var styles = window.getComputedStyle(thumbsWrap);
      var gap = parseFloat(styles.getPropertyValue('--liq-bb-thumb-gap') || styles.columnGap || styles.gap);
      return isNaN(gap) ? 10 : gap;
    }

    function thumbMetrics() {
      var totalShow = Math.max(state.realCount, getThumbButtons().length);
      var visible = Math.min(THUMB_VISIBLE, state.realCount || totalShow);
      var gap = thumbGap();
      var wrapW = thumbsWrap ? thumbsWrap.clientWidth : 0;
      var thumbW = visible > 0 ? (wrapW - gap * (visible - 1)) / visible : 0;
      return { visible: visible, gap: gap, thumbW: thumbW, step: thumbW + gap };
    }

    function setTrackTransition(on) {
      if (!thumbsTrack) return;
      thumbsTrack.style.transition = on ? '' : 'none';
    }

    function layoutThumbs() {
      if (!thumbsWrap || !thumbsTrack) return;
      var buttons = getThumbButtons();
      if (!buttons.length) return;
      var m = thumbMetrics();
      if (!(m.thumbW > 0)) return;

      buttons.forEach(function (btn) {
        btn.style.flex = '0 0 ' + m.thumbW + 'px';
        btn.style.width = m.thumbW + 'px';
        /* iOS Safari: aspect-ratio alone often collapses flex thumbs to a line */
        btn.style.height = m.thumbW + 'px';
        btn.style.minHeight = m.thumbW + 'px';
      });

      var shift = state.thumbOffset * m.step;
      thumbsTrack.style.transform = 'translate3d(' + (-shift) + 'px, 0, 0)';
    }

    function setupInfiniteThumbs() {
      if (!thumbsTrack) return;
      var real = Array.prototype.slice.call(getRealThumbs());
      state.realCount = real.length;
      state.looping = state.realCount > THUMB_VISIBLE;

      real.forEach(function (btn, idx) {
        if (!btn.hasAttribute('data-liq-slide-index')) {
          btn.setAttribute('data-liq-slide-index', String(idx));
        }
      });

      // Remove old clones from prior inits
      thumbsTrack.querySelectorAll('[data-liq-thumb-clone]').forEach(function (node) {
        node.parentNode.removeChild(node);
      });

      if (!state.looping) {
        state.thumbOffset = 0;
        return;
      }

      // Append first N clones for seamless forward wrap
      real.slice(0, THUMB_VISIBLE).forEach(function (btn) {
        var clone = btn.cloneNode(true);
        clone.classList.remove('is-active');
        clone.setAttribute('aria-pressed', 'false');
        clone.removeAttribute('data-liq-thumb');
        clone.setAttribute('data-liq-thumb-clone', '1');
        thumbsTrack.appendChild(clone);
      });

      // Prepend last N clones for seamless backward wrap
      real.slice(-THUMB_VISIBLE).reverse().forEach(function (btn) {
        var clone = btn.cloneNode(true);
        clone.classList.remove('is-active');
        clone.setAttribute('aria-pressed', 'false');
        clone.removeAttribute('data-liq-thumb');
        clone.setAttribute('data-liq-thumb-clone', '1');
        thumbsTrack.insertBefore(clone, thumbsTrack.firstChild);
      });

      // Start on the real first thumb (after prepended clones)
      state.thumbOffset = THUMB_VISIBLE;
    }

    function normalizeOffsetAfterTransition() {
      if (!state.looping || state.snapping) return;
      var n = state.realCount;
      var start = THUMB_VISIBLE;

      if (state.thumbOffset >= start + n) {
        state.snapping = true;
        setTrackTransition(false);
        state.thumbOffset -= n;
        layoutThumbs();
        void thumbsTrack.offsetHeight;
        setTrackTransition(true);
        state.snapping = false;
      } else if (state.thumbOffset < start) {
        state.snapping = true;
        setTrackTransition(false);
        state.thumbOffset += n;
        layoutThumbs();
        void thumbsTrack.offsetHeight;
        setTrackTransition(true);
        state.snapping = false;
      }
    }

    function goToThumbOffset(nextOffset, animate) {
      if (animate === false) setTrackTransition(false);
      state.thumbOffset = nextOffset;
      layoutThumbs();
      if (animate === false) {
        void thumbsTrack.offsetHeight;
        setTrackTransition(true);
        return;
      }
      window.setTimeout(normalizeOffsetAfterTransition, 320);
    }

    function applyActiveSlide(i) {
      var total = Math.max(slides.length, state.realCount || getRealThumbs().length);
      if (!total) return;
      state.slide = ((i % total) + total) % total;
      var slide = slides[state.slide];
      if (mainImg && slide) {
        if (slide.src) {
          mainImg.src = slide.src;
          mainImg.removeAttribute('hidden');
        }
        if (slide.alt) mainImg.alt = slide.alt;
      }
      getThumbButtons().forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-liq-slide-index'), 10);
        var on = idx === state.slide;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function ensureSlideVisible(slideIndex) {
      var n = state.realCount;
      if (!n || !state.looping) {
        state.thumbOffset = 0;
        layoutThumbs();
        return;
      }

      var start = THUMB_VISIBLE;
      var trackIndex = start + slideIndex;

      if (trackIndex < state.thumbOffset) {
        goToThumbOffset(trackIndex, true);
      } else if (trackIndex >= state.thumbOffset + THUMB_VISIBLE) {
        goToThumbOffset(trackIndex - THUMB_VISIBLE + 1, true);
      } else {
        layoutThumbs();
      }
    }

    function setSlide(i, fromThumbClick, trackPos) {
      if (!slides.length && !state.realCount) return;
      applyActiveSlide(i);

      if (fromThumbClick && state.looping && typeof trackPos === 'number') {
        var rel = trackPos - state.thumbOffset;
        // 4th / 5th visible → advance one step (strip moves left, next thumbs enter)
        if (rel >= 3) {
          goToThumbOffset(state.thumbOffset + 1, true);
          return;
        }
        // 1st–3rd: select only (no backward slide)
        layoutThumbs();
        return;
      }

      ensureSlideVisible(state.slide);
    }

    function bindThumbClicks() {
      var buttons = getThumbButtons();
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (state.suppressThumbClick) {
            e.preventDefault();
            e.stopPropagation();
            state.suppressThumbClick = false;
            return;
          }
          var idx = parseInt(btn.getAttribute('data-liq-slide-index'), 10);
          if (isNaN(idx)) return;
          // Live track position (works with clones + after drag)
          var trackPos = Array.prototype.indexOf.call(getThumbButtons(), btn);
          setSlide(idx, true, trackPos);
        });
      });
    }

    function bindThumbDrag() {
      if (!thumbsWrap || !thumbsTrack) return;
      if (state.realCount <= THUMB_VISIBLE) return;

      var drag = {
        active: false,
        dragging: false,
        pointerId: null,
        startX: 0,
        startOffset: 0
      };
      var DRAG_THRESHOLD = 8;

      function applyDragShift(dx) {
        var m = thumbMetrics();
        if (!m.step) return;
        var shift = drag.startOffset * m.step - dx;
        thumbsTrack.style.transform = 'translate3d(' + (-shift) + 'px, 0, 0)';
      }

      function endDrag(e) {
        if (!drag.active) return;
        if (drag.pointerId != null && thumbsWrap.hasPointerCapture && thumbsWrap.hasPointerCapture(drag.pointerId)) {
          try { thumbsWrap.releasePointerCapture(drag.pointerId); } catch (err) { /* ignore */ }
        }

        var wasDragging = drag.dragging;
        var dx = (e && typeof e.clientX === 'number' ? e.clientX : drag.startX) - drag.startX;

        drag.active = false;
        drag.dragging = false;
        drag.pointerId = null;

        // Tap / click — do not steal; let click handler select + advance 4th/5th
        if (!wasDragging) {
          setTrackTransition(true);
          return;
        }

        var m = thumbMetrics();
        var raw = drag.startOffset - (m.step ? dx / m.step : 0);
        var next = Math.round(raw);

        if (state.looping) {
          next = Math.max(0, Math.min(THUMB_VISIBLE + state.realCount, next));
        } else {
          next = Math.max(0, Math.min(Math.max(0, state.realCount - THUMB_VISIBLE), next));
        }

        state.suppressThumbClick = true;
        window.setTimeout(function () {
          state.suppressThumbClick = false;
        }, 250);

        setTrackTransition(true);
        state.thumbOffset = next;
        layoutThumbs();
        window.setTimeout(normalizeOffsetAfterTransition, 320);
      }

      thumbsWrap.addEventListener('pointerdown', function (e) {
        if (e.button != null && e.button !== 0) return;
        if (state.realCount <= THUMB_VISIBLE) return;
        drag.active = true;
        drag.dragging = false;
        drag.pointerId = e.pointerId;
        drag.startX = e.clientX;
        drag.startOffset = state.thumbOffset;
      });

      thumbsWrap.addEventListener('pointermove', function (e) {
        if (!drag.active || (drag.pointerId != null && e.pointerId !== drag.pointerId)) return;
        var dx = e.clientX - drag.startX;
        if (!drag.dragging && Math.abs(dx) < DRAG_THRESHOLD) return;

        if (!drag.dragging) {
          drag.dragging = true;
          setTrackTransition(false);
          try { thumbsWrap.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        }
        applyDragShift(dx);
      });

      thumbsWrap.addEventListener('pointerup', endDrag);
      thumbsWrap.addEventListener('pointercancel', endDrag);
    }

    /** Swipe/drag main product image left/right (desktop + mobile) */
    function bindMainSwipe() {
      var mainEl = root.querySelector('[data-liq-main]');
      if (!mainEl || !mainImg) return;

      var swipe = {
        active: false,
        pointerId: null,
        startX: 0,
        startY: 0,
        locked: null
      };
      var SWIPE_THRESHOLD = 40;
      var AXIS_LOCK = 10;

      function slideTotal() {
        return Math.max(slides.length, state.realCount || getRealThumbs().length);
      }

      function endSwipe(e) {
        if (!swipe.active) return;
        if (swipe.pointerId != null && mainEl.hasPointerCapture && mainEl.hasPointerCapture(swipe.pointerId)) {
          try { mainEl.releasePointerCapture(swipe.pointerId); } catch (err) { /* ignore */ }
        }

        var clientX = e && typeof e.clientX === 'number' ? e.clientX : swipe.startX;
        var dx = clientX - swipe.startX;
        var locked = swipe.locked;

        swipe.active = false;
        swipe.pointerId = null;
        swipe.locked = null;
        mainEl.classList.remove('is-swiping');

        if (locked !== 'x') return;
        if (Math.abs(dx) < SWIPE_THRESHOLD) return;
        if (slideTotal() < 2) return;

        // Swipe/drag left → next, right → previous
        if (dx < 0) {
          setSlide(state.slide + 1, false);
        } else {
          setSlide(state.slide - 1, false);
        }
      }

      mainEl.addEventListener('pointerdown', function (e) {
        if (slideTotal() < 2) return;
        if (e.button != null && e.button !== 0) return;
        swipe.active = true;
        swipe.pointerId = e.pointerId;
        swipe.startX = e.clientX;
        swipe.startY = e.clientY;
        swipe.locked = null;
      });

      mainEl.addEventListener('pointermove', function (e) {
        if (!swipe.active || (swipe.pointerId != null && e.pointerId !== swipe.pointerId)) return;
        var dx = e.clientX - swipe.startX;
        var dy = e.clientY - swipe.startY;

        if (!swipe.locked) {
          if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return;
          swipe.locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (swipe.locked === 'x') {
            mainEl.classList.add('is-swiping');
            try { mainEl.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
          }
        }

        if (swipe.locked === 'x' && e.cancelable) {
          e.preventDefault();
        }
      }, { passive: false });

      mainEl.addEventListener('pointerup', endSwipe);
      mainEl.addEventListener('pointercancel', endSwipe);
    }

    function flavorMeta(key) {
      var f = (cfg.flavors || {})[key] || {};
      return f;
    }

    function activeVariantId() {
      var f = flavorMeta(state.flavor);
      if (f.variantId) return String(f.variantId);
      if (variants[state.flavor]) return String(variants[state.flavor]);
      return cfg.fallbackVariantId ? String(cfg.fallbackVariantId) : '';
    }

    function isFlavorAvailable(key) {
      var f = flavorMeta(key);
      if (f.available === false || f.oos) return false;
      return true;
    }

    function applyFlavorStockUi() {
      var flavorsRoot = root.querySelector('[data-liq-flavors]');
      var synced = flavorsRoot && flavorsRoot.dataset.liqFlavorSynced === '1';
      flavorBtns.forEach(function (btn) {
        var key = btn.getAttribute('data-liq-flavor');
        var meta = btn.querySelector('.liq-buybox__flavor-meta');
        var oos = !isFlavorAvailable(key);
        // Theme Editor Liquid often fakes BL in-stock — keep OOS until product.js syncs
        if (!synced && key === 'bl' && window.Shopify && Shopify.designMode) {
          oos = true;
        }
        if (synced) {
          oos = btn.classList.contains('is-oos');
          var f = cfg.flavors && cfg.flavors[key];
          if (f && f.forceOos) oos = true;
          if (f) {
            f.oos = oos;
            f.available = !oos;
          }
        }
        btn.classList.toggle('is-oos', oos);
        if (oos) {
          btn.setAttribute('disabled', 'disabled');
        } else {
          btn.removeAttribute('disabled');
        }
        btn.setAttribute('aria-disabled', oos ? 'true' : 'false');
        if (meta) meta.textContent = oos ? 'Out of stock' : '30-serving tub';
      });
    }

    function normalizeImageUrl(url) {
      if (!url) return '';
      return String(url).split('?')[0].replace(/^https?:/, '');
    }

    function findSlideIndexForVariantImage(src) {
      if (!src || !slides.length) return -1;
      var needle = normalizeImageUrl(src);
      var i;
      for (i = 0; i < slides.length; i++) {
        var slideSrc = slides[i] && slides[i].src;
        if (!slideSrc) continue;
        var hay = normalizeImageUrl(slideSrc);
        if (hay === needle || hay.indexOf(needle) !== -1 || needle.indexOf(hay) !== -1) {
          return i;
        }
      }
      return -1;
    }

    function applyFlavorGallery(key) {
      var meta = flavorMeta(key);
      var src = meta.variantImageSrc;
      if (src) {
        var slideIdx = findSlideIndexForVariantImage(src);
        if (slideIdx >= 0) {
          setSlide(slideIdx);
          return;
        }
        if (mainImg) {
          mainImg.src = src;
          mainImg.removeAttribute('hidden');
          mainImg.alt = key === 'bl' ? 'Blueberry Lemonade' : 'Peach Mango';
        }
        return;
      }
      if (typeof meta.slideIndex === 'number') setSlide(meta.slideIndex);
    }

    function matchFlavorVariant(key, variants) {
      var f = cfg.flavors[key] || {};
      var id = f.variantId ? String(f.variantId).replace(/^.*\//, '') : '';
      var i;
      if (id) {
        for (i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === id) return variants[i];
        }
      }
      // Title fallback (Theme Editor / missing IDs)
      for (i = 0; i < variants.length; i++) {
        var title = String(variants[i].title || '').toLowerCase();
        if (title.indexOf('travel') !== -1) continue;
        if (key === 'pm' && (title.indexOf('peach') !== -1 || title.indexOf('mango') !== -1)) {
          return variants[i];
        }
        if (key === 'bl' && (title.indexOf('blueberry') !== -1 || title.indexOf('lemonade') !== -1)) {
          return variants[i];
        }
      }
      return null;
    }

    function syncAvailabilityFromProduct() {
      var handle = cfg.productHandle || 'lean-iq';
      if (!handle || !cfg.flavors) {
        applyFlavorStockUi();
        return Promise.resolve();
      }
      var url = '/products/' + encodeURIComponent(handle) + '.js?v=' + Date.now();
      return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) {
          return r.json();
        })
        .then(function (product) {
          var variants = product.variants || [];
          Object.keys(cfg.flavors).forEach(function (key) {
            var f = cfg.flavors[key];
            if (!f) return;
            var configuredId = f.variantId ? String(f.variantId).replace(/^.*\//, '') : '';
            var v = matchFlavorVariant(key, variants);
            if (!v) return;
            // Keep merchant-configured ID unless it was blank
            if (!configuredId) f.variantId = v.id;
            else f.variantId = configuredId;
            var qty = typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null;
            var available = !!v.available;
            if (qty !== null && qty <= 0) available = false;
            // Merchant / Haley pause: never re-enable a force-OOS flavor from live inventory
            if (f.forceOos) {
              available = false;
            }
            f.available = available;
            f.oos = !available;
            f.inventoryQty = qty;
            if (v.featured_image && v.featured_image.src) {
              f.variantImageSrc = v.featured_image.src;
            }
          });
          applyFlavorStockUi();
          if (!isFlavorAvailable(state.flavor)) {
            var keys = Object.keys(cfg.flavors);
            for (var k = 0; k < keys.length; k++) {
              if (isFlavorAvailable(keys[k])) {
                setFlavor(keys[k], { skipGallery: true });
                break;
              }
            }
          }
          // Do not jump main image to flavor variant on load/sync — keep first gallery slide.
        })
        .catch(function () {
          applyFlavorStockUi();
        });
    }

    function updatePrices() {
      var subTotal = subUnit * state.qty;
      var onceTotal = onceUnit * state.qty;
      var total = state.plan === 'sub' ? subTotal : onceTotal;

      if (subPriceEl) subPriceEl.textContent = money(subTotal);
      if (subWasEl) subWasEl.textContent = money(onceTotal);
      if (oncePriceEl) oncePriceEl.textContent = money(onceTotal);
      if (ctaLabel) {
        var prefix = cfg.ctaPrefix || 'Start now — ';
        ctaLabel.textContent = prefix + money(total);
      }
      if (qtyEl) qtyEl.textContent = String(state.qty);
      if (qtyInput) qtyInput.value = String(state.qty);
    }

    function setFlavor(key, opts) {
      if (!isFlavorAvailable(key)) return;
      state.flavor = key;
      var meta = flavorMeta(key);
      if (tasteEl && meta.tastes) tasteEl.textContent = meta.tastes;
      flavorBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-liq-flavor') === key;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (!opts || !opts.skipGallery) {
        applyFlavorGallery(key);
      }
      if (idInput) idInput.value = activeVariantId();
    }

    function setPlan(plan) {
      state.plan = plan;
      planCards.forEach(function (card) {
        var on = card.getAttribute('data-liq-plan') === plan;
        card.classList.toggle('is-active', on);
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
        var radio = card.querySelector('[data-liq-radio]');
        if (radio) radio.classList.toggle('is-on', on);
      });
      if (giftsWrap) giftsWrap.hidden = plan !== 'sub';
      if (planInput) {
        planInput.disabled = plan !== 'sub' || !sellingPlanId;
        planInput.value = plan === 'sub' ? sellingPlanId : '';
      }
      updatePrices();
    }

    function setQty(n) {
      state.qty = Math.max(1, Math.min(maxQty, n));
      updatePrices();
    }

    function setAcc(i) {
      if (i < 0) {
        state.openAcc = -1;
      } else {
        state.openAcc = state.openAcc === i ? -1 : i;
      }
      renderAcc();
    }

    function renderAcc() {
      accItems.forEach(function (item, idx) {
        var open = idx === state.openAcc;
        item.classList.toggle('is-open', open);
        var btn = item.querySelector('[data-liq-acc-btn]');
        var panel = item.querySelector('[data-liq-acc-panel]');
        if (btn) {
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          var sign = btn.querySelector('[data-liq-acc-sign]');
          if (sign) sign.textContent = open ? '−' : '+';
        }
        if (panel) {
          if (open) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', 'hidden');
        }
      });
    }

    setupInfiniteThumbs();
    bindThumbClicks();
    bindThumbDrag();
    bindMainSwipe();
    layoutThumbs();
    /* iOS: re-measure after fonts/images/layout settle */
    window.requestAnimationFrame(function () {
      layoutThumbs();
      window.setTimeout(layoutThumbs, 250);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layoutThumbs, 100);
    });

    if (thumbsTrack) {
      thumbsTrack.addEventListener('transitionend', function (e) {
        if (e.target !== thumbsTrack) return;
        if (e.propertyName && e.propertyName.indexOf('transform') === -1) return;
        normalizeOffsetAfterTransition();
      });
    }

    flavorBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setFlavor(btn.getAttribute('data-liq-flavor'));
      });
    });

    var flavorsWrap = root.querySelector('[data-liq-flavors]');
    if (flavorsWrap) {
      flavorsWrap.addEventListener('liq:flavor-stock-synced', function () {
        Object.keys(cfg.flavors || {}).forEach(function (key) {
          var btn = root.querySelector('[data-liq-flavor="' + key + '"]');
          if (!btn) return;
          var oos = btn.classList.contains('is-oos');
          var f = cfg.flavors[key];
          if (f) {
            f.oos = oos;
            f.available = !oos;
          }
        });
        applyFlavorStockUi();
        if (!isFlavorAvailable(state.flavor)) {
          var keys = Object.keys(cfg.flavors || {});
          for (var i = 0; i < keys.length; i++) {
            if (isFlavorAvailable(keys[i])) {
              setFlavor(keys[i]);
              break;
            }
          }
        }
      });
    }

    planCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('a')) return;
        setPlan(card.getAttribute('data-liq-plan'));
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setPlan(card.getAttribute('data-liq-plan'));
        }
      });
    });

    var dec = root.querySelector('[data-liq-qty-dec]');
    var inc = root.querySelector('[data-liq-qty-inc]');
    if (dec) dec.addEventListener('click', function () { setQty(state.qty - 1); });
    if (inc) inc.addEventListener('click', function () { setQty(state.qty + 1); });

    accItems.forEach(function (item, idx) {
      var btn = item.querySelector('[data-liq-acc-btn]');
      if (btn) {
        btn.addEventListener('click', function () {
          setAcc(idx);
        });
      }
    });

    var cartAddUrl =
      (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js');

    var addInFlight = false;

    function sectionIdsForCart() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
      });
      return ids;
    }

    function parseCartAddResponse(res, data) {
      // Horizon product-form treats response.status as an error payload even on HTTP 200
      if (!res.ok || (data && data.status && data.message)) {
        var msg =
          (data && (data.description || data.message)) ||
          'Could not add to cart';
        var err = new Error(msg);
        err.cartData = data;
        throw err;
      }
      return data;
    }

    async function postCartAdd(items) {
      var payload = { items: items };
      var sections = sectionIdsForCart();
      if (sections.length) payload.sections = sections.join(',');

      var res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      });

      var data = null;
      try {
        data = await res.json();
      } catch (parseErr) {
        throw new Error('Could not add to cart');
      }
      return parseCartAddResponse(res, data);
    }

    function afterAddAction() {
      return cfg.afterAddAction || (cfg.openCart === false ? 'cart' : 'drawer');
    }

    function notifyCartUpdated(data, variantId) {
      var action = afterAddAction();
      if (action === 'cart' || action === 'checkout') {
        return;
      }
      var detail = {
        resource: data,
        sourceId: root.id || 'leaniq-buybox',
        data: {
          source: 'leaniq-buybox',
          itemCount: state.qty,
          variantId: String(variantId),
          sections: data && data.sections
        }
      };
      // Savor cart drawer auto-opens on cart:update (CartAddEvent)
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
    }

    function shopRoot() {
      return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    }

    function closeCartDrawerIfOpen() {
      var drawer =
        document.querySelector('cart-drawer-component') ||
        document.querySelector('cart-drawer, cart-notification, #CartDrawer');
      if (!drawer) return;
      if (typeof drawer.close === 'function') drawer.close();
      else if (typeof drawer.closeDialog === 'function') drawer.closeDialog();
    }

    function afterSuccessfulAdd() {
      var action = afterAddAction();
      if (action === 'checkout') {
        closeCartDrawerIfOpen();
        window.location.assign(shopRoot() + 'checkout');
        return;
      }
      if (action === 'cart') {
        closeCartDrawerIfOpen();
        window.location.assign(shopRoot() + 'cart');
        return;
      }
      openCartDrawer();
    }

    function openCartDrawer() {
      var drawer =
        document.querySelector('cart-drawer-component') ||
        document.querySelector('cart-drawer, cart-notification, #CartDrawer');
      if (drawer) {
        if (typeof drawer.open === 'function') {
          drawer.open();
          return;
        }
        if (typeof drawer.showDialog === 'function') {
          drawer.showDialog();
          return;
        }
      }
      if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function') {
        window.theme.cartDrawer.open();
        return;
      }
      window.location.href = shopRoot() + 'cart';
    }

    async function addToCart() {
      if (addInFlight) return;

      var variantId = activeVariantId();
      if (!variantId || !Number(variantId)) {
        if (statusEl) {
          statusEl.hidden = false;
          statusEl.textContent = cfg.missingVariantMsg || 'Select an available flavor to continue.';
        }
        return;
      }

      if (!isFlavorAvailable(state.flavor)) {
        if (statusEl) {
          statusEl.hidden = false;
          statusEl.textContent = 'That flavor is sold out. Pick another to continue.';
        }
        return;
      }

      addInFlight = true;
      if (ctaBtn) {
        ctaBtn.disabled = true;
        if (showCtaLoading) {
          ctaBtn.classList.add('is-loading');
          ctaBtn.setAttribute('aria-busy', 'true');
          if (ctaLabel) ctaLabel.textContent = ctaLoadingLabel;
        }
      }
      if (statusEl) {
        statusEl.hidden = true;
        statusEl.textContent = '';
      }

      if (idInput) idInput.value = String(variantId);
      if (qtyInput) qtyInput.value = String(state.qty);
      if (planInput) {
        var usePlan = state.plan === 'sub' && sellingPlanId;
        planInput.disabled = !usePlan;
        planInput.value = usePlan ? String(sellingPlanId) : '';
      }

      var mainItem = {
        id: Number(variantId),
        quantity: state.qty
      };
      if (state.plan === 'sub' && sellingPlanId) {
        mainItem.selling_plan = Number(sellingPlanId);
      }

      try {
        // Add tub first so a gift-line failure cannot block Subscribe / OTP
        var data = await postCartAdd([mainItem]);

        if (
          state.plan === 'sub' &&
          addTravelPackGift &&
          travelPackVariantId &&
          String(travelPackVariantId) !== String(variantId)
        ) {
          try {
            // Keep Travel Pack as OTP one-time gift (no selling_plan) so Loop
            // does not renew it. Free-shipping discount must allow mixed carts.
            await postCartAdd([
              {
                id: Number(travelPackVariantId),
                quantity: 1,
                properties: { _liq_sub_gift: 'travel_pack' }
              }
            ]);
          } catch (giftErr) {
            // Gift is best-effort; tub is already in cart
            console.warn('[leaniq-buybox] travel pack gift skipped', giftErr);
          }

          /* Extra referral Travel Pack (does not replace _liq_sub_gift). */
          try {
            if (window.LiqReferralGift && typeof window.LiqReferralGift.afterSubscribeAdd === 'function') {
              await window.LiqReferralGift.afterSubscribeAdd(travelPackVariantId);
            }
          } catch (refErr) {
            console.warn('[leaniq-buybox] referral travel pack skipped', refErr);
          }
        }

        notifyCartUpdated(data, variantId);
        afterSuccessfulAdd();
      } catch (err) {
        if (statusEl) {
          statusEl.hidden = false;
          statusEl.textContent = (err && err.message) || 'Something went wrong. Please try again.';
        }
      } finally {
        addInFlight = false;
        if (ctaBtn) {
          ctaBtn.disabled = false;
          ctaBtn.classList.remove('is-loading');
          ctaBtn.setAttribute('aria-busy', 'false');
        }
        updatePrices();
      }
    }

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart();
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart();
      });
    }

    // Init
    if (!isFlavorAvailable(state.flavor)) {
      var keys = Object.keys(cfg.flavors || {});
      for (var i = 0; i < keys.length; i++) {
        if (isFlavorAvailable(keys[i])) {
          state.flavor = keys[i];
          break;
        }
      }
    }
    // Flavor UI only on load — main image stays on first Admin/gallery slide
    setFlavor(state.flavor, { skipGallery: true });
    setPlan(state.plan);
    setQty(1);
    setSlide(0);
    state.openAcc = -1;
    renderAcc();
    layoutThumbs();
    applyFlavorStockUi();
    syncAvailabilityFromProduct();
    // Theme Editor can paint before inventory JSON is ready — retry briefly
    window.setTimeout(syncAvailabilityFromProduct, 400);
    window.setTimeout(syncAvailabilityFromProduct, 1200);
    if (window.Shopify && Shopify.designMode) {
      window.setTimeout(syncAvailabilityFromProduct, 2500);
      window.setTimeout(syncAvailabilityFromProduct, 5000);
    }
    scrollToOffersIfHash(root);
  }

  function boot() {
    document.querySelectorAll('[data-liq-buybox]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var root = e.target.querySelector('[data-liq-buybox]') || (e.target.matches && e.target.matches('[data-liq-buybox]') ? e.target : null);
    if (root) {
      root.dataset.liqBuyboxReady = '';
      init(root);
    }
    if (window.liqSyncFlavorStock) window.liqSyncFlavorStock();
  });
})();
